import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './translation.en.json';
import ko from './translation.ko.json';

export const LANG_KO_KR = 'ko';
export const LANG_EN_US = 'en';
export const LANG_KO_KR_CODE = 'ko_KR';
export const LANG_EN_US_CODE = 'en_US';

// URL 파라미터에서 언어 코드 추출
const getLangCodeFromParams = () => {
  try {
    const params = new URL(window.location.href).searchParams;
    const lang = params.get('lang');
    return lang;
  } catch (err) {
    console.log('err: ', err);
    throw err;
  }
};

const getLangCodeFromUA = () => {
  try {
    const parse = /Polaris\/\d.?\d \(.*,\s?(.*-.*)\)/g.exec(navigator.userAgent);
    if (!parse) return undefined;
    return parse[1];
  } catch (err) {
    console.log('err: ', err);
    throw err;
  }
};

// 언어 코드 변환
// ko_KR -> ko, en_US -> en
export const convertLangFromLangCode = (code: string | undefined) => {
  try {
    const lower = code?.toLowerCase();
    if (lower?.startsWith('ko')) {
      return LANG_KO_KR;
    } else {
      return LANG_EN_US;
    }
  } catch (err) {
    return LANG_EN_US;
  }
};

// 최종으로 사용할 언어 결정(en, ko)
export const getLang = () => {
  try {
    const paramLang = getLangCodeFromParams() || getLangCodeFromUA();
    return convertLangFromLangCode(paramLang);
  } catch (err) {
    return LANG_EN_US;
  }
};

// 언어 코드 결정(ko_KR, en_US)
const getLangCode = () => {
  const code = getLangCodeFromParams() || getLangCodeFromUA() || LANG_EN_US_CODE;
  try {
    const lower = code?.toLowerCase();
    if (lower?.startsWith('ko')) {
      return LANG_KO_KR_CODE;
    } else {
      return LANG_EN_US_CODE;
    }
  } catch (err) {
    return LANG_EN_US_CODE;
  }
};
export const lang = getLang();
export const langCode = getLangCode();

const resources = {
  ko: {
    translation: ko
  },
  en: {
    translation: en
  }
};

i18n.use(LanguageDetector).use(initReactI18next).init({
  resources,
  lng: lang,
  fallbackLng: 'en'
});

export default i18n;
